import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";

/**
 * GenerateCategoriaAssistenciaListaColumnDefinition
 */

type Props = {
  onActionEditar: (idCategoriaAssistencia: number, openModal: boolean) => void;
  onActionDelete: (idCategoriaAssistencia: number, openModal: boolean) => void;
};

export const GenerateCategoriaAssistenciaListaColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(value)}
            color={computeItemStatusColor(value)}
            description={computeItemStatusDescription(value)}
          />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: 'idCategoriaAssistencia',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}